<template>
    <v-container class="grey lighten-5" fluid>
        <live v-if="state"></live>
        <test v-else-if="!state"></test>
    </v-container>
</template>

<script>
import Live from '../components/transactions/Live.vue';
import Test from '../components/transactions/Test.vue';

export default {
    data() {
        return {
            
        }
    },
    components: {
        'live': Live,
        'test': Test
    },
    computed: {
        state() {
            return this.$store.state.sysState;
        }
    },
    methods: {
       
    }
}
</script>

<style>

</style>